import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as movie from '../../app/pages/redux/MovieRedux'
import * as contract from '../../app/pages/redux/ContractRedux'
import * as agGrid from '../../app/pages/redux/AgGridTableRedux'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  movie: movie.reducer,
  contract: contract.reducer,
  agGrid: agGrid.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga(), movie.saga(), contract.saga()])
}
